module.exports = __webpack_public_path__ + "img/guitar-electric.df60779c.svg";